import { render, staticRenderFns } from "./ComplianceStatusBadge.vue?vue&type=template&id=8b975f3a"
import script from "./ComplianceStatusBadge.vue?vue&type=script&lang=js"
export * from "./ComplianceStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports